// Module
var code = "<div ui-view id=\"mx-app\" mx-css-variables></div>";
// Exports
export default code;